import script from "./SectionSplitLinks.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionSplitLinks.vue?vue&type=script&setup=true&lang=js"

import "./SectionSplitLinks.vue?vue&type=style&index=0&id=54baa3c3&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54baa3c3"]])

export default __exports__